export default __webpack_public_path__ + "static/media/Maasin_logo.1fb60a7e.png";